<template>
    <div>
        <span class="col-value" v-show="!editing" @click="startEditing">
            {{newValue ? newValue : value}}
        </span>

        <input v-show="editing"  class="form-control"
               v-model="newValue" ref="input" placeholder="0">
        
        <button  v-show="editing" class="btn btn-primary btn-sm mx-2 my-2 px-2" @click="saveEditing"  >{{ Lang.get('messages.save') }}</button>       
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                required: true
            },
        },

        data() {
            return {
                editing: false,
                newValue: null,
            }
        },

        methods: {
            startEditing() {
                this.editing = true;
                this.newValue = null;
                this.$nextTick(function () {
                    this.$refs.input.focus();
                });
            },

            saveEditing() {
                this.editing = false;
                if (this.newValue) {
                    this.$emit('update', this.newValue);
                }
            },

            cancelEditing() {
                this.editing = false;
            },
        }
    };
</script>

<style>
</style>